import { BrowserRouter as Router } from 'react-router-dom'
import { Navigate, Route, Routes } from 'react-router'
import styled from "@emotion/styled";
import "antd/dist/antd.css"
import './App.css';
import { Banner } from "./banner";
import { NaviBar } from "./navi-bar";
import { HomePage } from './home-page';
import { CompanyProfiles } from './company-profiles';
import { CenterBox } from './compnents';
import { ContentService } from './content-service';
import { ContractUs } from './contract-us';
import { FooterContent } from './footer-content';

function App() {
    return (
        <div className="App">
            <Router>
                <Header>
                    <Banner />
                    <CenterBox style={{ top: '2.03vw' }}><NaviBar /></CenterBox>
                    <CenterBox style={{ top: '17.5vw', flexDirection: 'column', alignItems: 'center' }}>
                        <h1 style={{ color: 'white', letterSpacing: '1.8rem', marginBottom: '0', whiteSpace: 'nowrap' }}>让金融更轻松</h1>
                        <h3 style={{ letterSpacing: '0.5rem', color: 'white', backgroundColor: '#c9b17a', whiteSpace: 'nowrap' }}>
                            Make&nbsp;finance&nbsp;easier
                        </h3>
                    </CenterBox>
                </Header>
                <Content>
                    <Routes>
                        <Route path={'/'} element={<HomePage />} />
                        <Route path={'/companyprofiles'} element={<CompanyProfiles />} />
                        <Route path={'/contentservice'} element={<ContentService />} />
                        <Route path={'/contractus'} element={<ContractUs />} />
                        <Navigate to={'/'} />
                    </Routes>
                </Content>
                <Footer>
                    <FooterContent />
                    <div style={{ position: 'relative' }}>
                        <CenterBox style={{ top: '0rem', height: '9.6rem', alignItems: 'center', backgroundColor: '#4c4c4c' }}>
                            <span style={{ fontSize: '1.4rem' }}>版权所有&nbsp; &nbsp; 北京远见未来信息科技有限公司&nbsp; &nbsp; <a href="https://beian.miit.gov.cn/" rel="noopener noreferrer" target="_blank">北京ICP备&nbsp; &nbsp;16057617号-2</a></span>
                        </CenterBox>
                    </div>
                </Footer>
            </Router>
        </div>
    );
}

const Header = styled.div`
position: relative;
height: 41vw;
`

const Content = styled.div`
position: relative;
`

const Footer = styled.div`
position: relative;
background-color: #373839;
color: white;
`
export default App;
